module.exports = __webpack_public_path__ + "img/faq01.bd170483.svg";